<ng-container [formGroup]="parentFormGroup">
  <pg-checkbox
    [formControlName]="checkboxModel?.formControlName"
    [id]="checkboxModel?.id"
    [alignment]="checkboxModel?.checkBoxAlignment"
    [styleOverrides]="checkboxModel"
    [htmlOverride]="checkboxModel?.innerHTML"
    >{{ checkboxModel?.label }}</pg-checkbox
  >
</ng-container>
